import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  message = 'Loading...', 
  showMessage = true,
  variant = 'primary',
  className = '' 
}) => {
  // Size classes
  const sizeClasses = {
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border-lg'
  };

  // Variant classes
  const variantClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    success: 'text-success',
    danger: 'text-danger',
    warning: 'text-warning',
    info: 'text-info',
    light: 'text-light',
    dark: 'text-dark'
  };

  return (
    <div className={`loading-spinner text-center ${className}`}>
      <div 
        className={`spinner-border ${sizeClasses[size]} ${variantClasses[variant]}`}
        role="status"
        aria-hidden="true"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      {showMessage && message && (
        <div className="mt-2">
          <small className="text-muted">{message}</small>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;